import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';

function Routing() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/:certificateNo" element={<App />}  />
            </Routes>
        </Router>
    );
}

export default Routing;